import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Home from './views/Home'
import About from "./views/About";
import { ThemeProvider } from "./themeProvider";
import LoadingScreen from "./components/LoadingScreen";
import Projects from "./views/Projects";
import Contact from "./views/Contact";
import Experience from "./views/Experience";
import Education from "./views/Education";

function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => setLoading(false), 1000)
  }, [])

  return (
    <ThemeProvider>
      <>

        {!loading ? (
          <div >
            <Navbar />
            <Home />
            <About />
            <Education />
            <Experience />
            <Projects/>
            <Contact />
          </div>

        ) : (
          <LoadingScreen />
        )}
        {!loading && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="fixed bottom-6 right-6 bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg hover:bg-blue-700 transition"
            aria-label="Back to Top"
          >
            ↑
          </button>
        )}
      </>
      </ThemeProvider>
  );
}

export default App;
